import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import { Toaster } from "sonner";
import LightboxProvider from "@/components/LightboxProvider";

import Header from "@/components/Header";
import ContactFooter from "@/components/ContactFooter";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";
import CategoryPage from "@/pages/CategoryPage";

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#0A0A0A]">
      <Header />
      <div className="flex-1">{children}</div>
      <ContactFooter />
    </div>
  );
}

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <LightboxProvider>
          <Routes>
            <Route path="/" element={<Layout><HomePage /></Layout>} />
            <Route path="/category/:key" element={<Layout><CategoryPage /></Layout>} />
            <Route path="/admin" element={<Layout><AdminPage /></Layout>} />
          </Routes>
        </LightboxProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0d0d0d",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#fff",
          },
        }}
      />
    </I18nProvider>
  );
}

export default App;
